import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * SharedModule
 *
 * Contains commonly used directives, pipes, and components
 * that need to be shared across feature modules.
 *
 * Import this module in any feature module that needs access
 * to these shared resources.
 */
@NgModule({
  declarations: [],
  imports: [CommonModule],
  exports: []
})
export class SharedModule {}
